/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefMarkdownData } from '../../models/api-def-markdown-data';
import { ApiDefProjectData } from '../../models/api-def-project-data';

export interface OrganizationsUpdateMarkdownVersion$Params {

/**
 * The ID of the organization to update the markdown version in
 */
  organizationId: string;

/**
 * The ID of the project to update the markdown version in
 */
  projectId: string;

/**
 * The ID of the upload intent to update the markdown version for
 */
  uploadIntentId: string;
      body: {

/**
 * The name of the markdown version
 */
'versionName'?: string;

/**
 * The status of the markdown version
 * Possible values:
 * - `public` - The markdown version is public and can be accessed by anyone.
 * - `private` - The markdown version is private and can only be accessed by viewers of the organization.
 * - `hidden` - The markdown version is hidden and cannot be accessed by anyone.
 */
'status'?: 'public' | 'private' | 'hidden';
}
}

export function organizationsUpdateMarkdownVersion(http: HttpClient, rootUrl: string, params: OrganizationsUpdateMarkdownVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsUpdateMarkdownVersion.PATH, 'patch');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('projectId', params.projectId, {});
    rb.path('uploadIntentId', params.uploadIntentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'project'?: ApiDefProjectData;
      'markdown'?: ApiDefMarkdownData;
      }>;
    })
  );
}

organizationsUpdateMarkdownVersion.PATH = '/organizations/{organizationId}/projects/{projectId}/markdowns/{uploadIntentId}';
